<template>
    <div class="div">
        <button class="button is-small" :class="{'bold' : isFilled }" @click="openModal" style="width: 55px;">
            {{ car.export_certificate ? formatDate(car.export_certificate) : '---' }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Export Certificate</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <article v-if="error.status" class="message is-danger">
                        <div class="message-body">
                            <strong>{{ error.message }}!</strong>
                        </div>
                    </article>
                    <article v-if="success" class="message is-success">
                        <div class="message-body">
                            <strong>Success!</strong> File was uploaded!
                        </div>
                    </article>
                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field">
                                <input type="number" @keyup="calculateCbm" placeholder="Type Length" class="input is-small" v-model="carData.query.length"/>
                            </div>
                            <div class="field">
                                <input type="number" @keyup="calculateCbm" placeholder="Type Width" class="input is-small" v-model="carData.query.width"/>
                            </div>
                            <div class="field">
                                <input type="number" @keyup="calculateCbm" placeholder="Type Height" class="input is-small" v-model="carData.query.height"/>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field">
                                <datetime
                                        input-class="input is-small"
                                        v-model="carData.query.export_certificate"
                                        :format="{ month: 'numeric', day: 'numeric'}"
                                        type="date"
                                        value-zone="local"
                                        zone="local"
                                        :input-id="carData.id.toString()"
                                        placeholder="Select date"
                                ></datetime>
                            </div>
                            <div class="field">
                                <input type="number" placeholder="Type Kg's" class="input is-small" v-model="carData.query.kgs"/>
                            </div>
                            <div class="field">
                                <input type="number" placeholder="Type CBM" class="input is-small" v-model="carData.query.cbm"/>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <div class="file has-name is-boxed">
                            <label class="file-label">
                                <input class="file-input" ref="file" v-on:change="handleFileUpload()" type="file">
                                <span class="file-cta">
                                  <span class="file-icon">
                                    <i class="fas fa-upload"></i>
                                  </span>
                                  <span class="file-label">
                                    Choose a file…
                                  </span>
                                </span>
                                <span class="file-name">
                                  {{ fileName }}
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Expected Exportation:</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <datetime
                                        input-class="input is-small"
                                        v-model="carData.query.expected_exportation"
                                        :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                        type="date"
                                        value-zone="local"
                                        zone="local"
                                        :input-id="carData.id.toString()"
                                        placeholder="Select date"
                                ></datetime>
                            </div>
                        </div>
                    </div>
                    <p v-if="noFiles" class="text-centered">No Files</p>
                    <div v-for="element in uploadedDocument"  @dblclick="selectFile(element)" :class="{'is-focused': isSelected(element)}" class="button select-image">
                        {{ element.split("/").pop() }}
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button"  @click="isActive = !isActive" :class="{ 'is-loading': isLoading }">Close</button>
                    <button class="button is-primary"  @click="saveChanges" :class="{ 'is-loading': isLoading }">Save</button>
                    <button class="button" @click="showUploadedFiles" :class="{ 'is-loading': isLoading }">Show Uploaded Files</button>
                    <button class="button is-danger" v-if="readyToDelete" @click="deleteSelectedFiles" :class="{ 'is-loading': isLoading }"><i class="fas fa-trash-alt"></i></button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiCars from './../../../api/apiCars'
    import apiExportCertificates from './../../../api/apiExportCertificates'
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import moment from 'moment'
    export default {
        props:['car'],
        components: {
            Datetime
        },
        data () {
            return {
                isActive: false,
                success: false,
                documents: null,
                fileName: 'Only PDF file.',
                error: {
                    status: false,
                    message: []
                },
                carData:{
                    id: this.car.id,
                    query: {
                        expected_exportation: this.car.expected_exportation,
                        export_certificate: this.car.export_certificate,
                        height: this.car.height,
                        width: this.car.width,
                        length: this.car.length,
                        kgs: this.car.kgs,
                        cbm: this.car.cbm
                    }
                },
                uploadedDocument: null,
                selectedFiles: [],
                noFiles: false,
                mediaLoaded:false,
                isLoading: false,
            }
        },
        methods: {
            formatDate(date) {
                if(date){
                    return moment(date).format('M/D')
                }else{
                    return '---'
                }
            },
            openModal() {
                this.success = false
                this.isActive = !this.isActive
            },
            handleFileUpload(){
                this.documents = this.$refs.file.files[0];
                this.fileName = this.$refs.file.files[0].name;
            },
            saveChanges() {
                this.isLoading = true
                this.success = false
                if (this.documents !== null) {
                    if (!this.carData.query.expected_exportation.length > 0) {
                        this.isLoading = false
                        this.error.status = true
                        this.error.message = 'Please enter the Expected Exportation Date'
                        return
                    }
                    let formData = new FormData();

                    formData.append('certificate', this.documents);
                    formData.append('car_id',  this.car.id);

                    apiCars
                        .carsUploadDocumentsRequest(formData)
                        .then((response) => {
                            this.isLoading = false
                            this.success = true
                            this.fileName = 'Only PDF file.'
                        })
                        .catch(error => {
                            this.isLoading = false
                            console.log(error)
                            if ( error.response && error.response.status === 422 ) {
                                this.error.status = true
                                this.error.message = 'The documents must be a file of type: pdf.'
                            }
                        })
                }
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.isLoading = false
                        this.car.export_certificate = this.carData.query.export_certificate
                        this.car.height = this.carData.query.height
                        this.car.width = this.carData.query.width
                        this.car.length = this.carData.query.length
                        this.car.kgs = this.carData.query.kgs
                        this.car.cbm = this.carData.query.cbm
                    })
                    .catch(error => {
                        this.isLoading = false
                        console.log(error)
                    })
            },
            showUploadedFiles() {
                apiCars
                    .getCarDocumentsRequest(this.car.id)
                    .then((response) => {
                        this.mediaLoaded = true
                        this.uploadedDocument = response.data.export_certificates
                        this.noFiles = response.data.export_certificates === null
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            selectFile(file) {
                if (this.selectedFiles.includes(file)) {
                    this.selectedFiles = this.selectedFiles.filter(item => item !== file)

                } else {
                    this.selectedFiles.push(file)
                }
            },
            deleteSelectedFiles() {
                this.error.status = false
                this.isLoading = true
                this.success = false
                let query = {
                    media: this.selectedFiles
                }
                apiCars
                    .deleteCarMediaFilesRequest(query)
                    .then((response) => {
                        this.isLoading = false
                        this.selectedFiles = []
                        this.showUploadedFiles()
                    })
                    .catch(error => {
                        this.selectedFiles = []
                        this.isLoading = false
                        console.log(error)

                    })
            },
            isSelected(file) {
                return this.selectedFiles.includes(file)
            },
            calculateCbm() {
                let height = this.carData.query.height
                let width = this.carData.query.width
                let length = this.carData.query.length
                let total = height * width * length
                this.carData.query.cbm = total.toFixed(2)
            }

        },
        computed: {
            isFilled() {
                if (this.formatDate(this.carData.query.export_certificate) !== '---'){
                    return  true;
                }
            },
            readyToDelete() {
                return this.selectedFiles.length > 0
            },
        },
        created() {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/ExportCertificateColumn.vue